import React from 'react';
import { useNavigate } from 'react-router-dom';
import { generateArticleUrl } from '../../utils/urlHelper';
import WeatherWidget from './WeatherWidget'; // ✅ Import the weather widget

const Sidebar = ({ articles }) => {
    const navigate = useNavigate();
    const trending = articles.slice(0, 8);

    return (
        <>
            <div className="sidebar-box" style={{ background: '#fff', border: '1px solid var(--lgray)', borderRadius: '3px', padding: '16px', marginBottom: '20px' }}>
                <div className="sb-title" style={{ fontFamily: 'var(--ff-label)', fontSize: '17px', letterSpacing: '1.5px', color: '#fff', background: 'var(--navy)', margin: '-16px -16px 14px', padding: '10px 14px' }}>🔥 Trending Now</div>
                {trending.map((article, idx) => (
                    <div
                        key={article._id}
                        className="trending-item"
                        style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '8px 0', borderBottom: '1px solid var(--lgray)', cursor: 'pointer' }}
                        onClick={() => navigate(generateArticleUrl(article))}
                    >
                        <div className="num" style={{ fontFamily: 'var(--ff-label)', fontSize: '22px', color: 'var(--red)', lineHeight: 1, width: '28px', flexShrink: 0 }}>{idx + 1}</div>
                        <div>
                            <h6 style={{ fontSize: '13px', lineHeight: '1.4', fontWeight: '600' }}>{article.title}</h6>
                            <div className="meta" style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>📅 {article.date}</div>
                        </div>
                    </div>
                ))}
            </div>

            {/* ✅ Dynamic Weather Widget - Replaces static weather HTML */}
            <WeatherWidget />

            <div className="poll-widget" style={{ background: 'var(--navy)', color: '#fff', borderRadius: '3px', padding: '16px', marginBottom: '20px' }}>
                <div className="ptitle" style={{ fontFamily: 'var(--ff-label)', fontSize: '14px', letterSpacing: '1px', color: 'var(--gold)', marginBottom: '8px' }}>📊 TODAY'S POLL</div>
                <h5 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '14px' }}>Should India adopt a 4-day work week?</h5>
                <div className="poll-option" style={{ marginBottom: '8px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px' }}>
                        <input type="radio" name="poll" value="yes" /> Yes, it boosts productivity
                    </label>
                    <div className="poll-bar" style={{ height: '6px', background: 'rgba(255,255,255,.2)', borderRadius: '3px', marginTop: '4px', overflow: 'hidden' }}>
                        <div className="poll-bar-inner" style={{ height: '100%', background: 'var(--red)', borderRadius: '3px', width: '62%' }}></div>
                    </div>
                </div>
                <div className="poll-option" style={{ marginBottom: '8px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px' }}>
                        <input type="radio" name="poll" value="no" /> No, economy needs full days
                    </label>
                    <div className="poll-bar" style={{ height: '6px', background: 'rgba(255,255,255,.2)', borderRadius: '3px', marginTop: '4px', overflow: 'hidden' }}>
                        <div className="poll-bar-inner" style={{ height: '100%', background: 'var(--red)', borderRadius: '3px', width: '28%' }}></div>
                    </div>
                </div>
                <button className="btn btn-red" style={{ marginTop: '12px', fontSize: '12px' }} onClick={() => alert('Vote submitted!')}>Vote Now</button>
            </div>
        </>
    );
};

export default Sidebar;